import "reflect-metadata";
import {inject, injectable} from "inversify";
import {SectorRepository} from "@dropDesk/domain/repositories/sector/sector.repository";
import {Observable} from "rxjs";
import {ExportDataEntity} from "@dropDesk/domain/entities/export_data/export_data_entity";

@injectable()
export class ExportDataSectorSubscriptionUseCase {
  private _repository: SectorRepository;

  constructor(@inject(SectorRepository) repository: SectorRepository) {
    this._repository = repository;
  }

  public call(
      id: string,
      handleDisconnect: (temporary: boolean) => void,
      getLastUpdates: () => void,
      useSocket: boolean
  ): Observable<ExportDataEntity | null> {
    return this._repository.exportSubscription(id, handleDisconnect, getLastUpdates, useSocket);
  }
}

